export default "__VITE_ASSET__SapYMNfC__"